import { useTranslation } from "react-i18next";
import { StatusBadge } from "@athena/ui";
import type { ContactStatus } from "../helpers/client";
import { CONTACT_STATUS_VARIANT } from "../helpers/client";

export function ContactStatusBadge({ status }: { status: ContactStatus }) {
    const { t } = useTranslation();
    return <StatusBadge variant={CONTACT_STATUS_VARIANT[status]}>{t(`admin.alumni.status.${status}`)}</StatusBadge>;
}
